<script>
import {Modal} from 'iview'
export default {
  name: 'Modal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'large'
    },
    map: {
      type: Object,
      default () {
        return {}
      }
    },
    isMiddle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: '确认'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default () {
        return {}
      }
    },
    className: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showModal: false,
      inTitle: this.title
    }
  },
  computed: {
    width () {
      return this.map[this.size]
    }
  },
  watch: {
    value (newVal) {
      this.$nextTick(() => {
        this.showModal = newVal
        !newVal && this.removeHidden()
        newVal && this.addUitClass()
        newVal && this.$nextTick(() => {
          this.$refs.customModal.visible = true
        })
      })
    },
    title (val) {
      this.inTitle = val
    }
  },
  created () {
    let defaultMap = {
      full: '100%',
      superLarge: '1425',
      bigLarge: '1000',
      large: '768',
      small: '416'
    }
    this.map = Object.assign(this.map, defaultMap)
  },
  render (c) {
    return this.showModal ? c('div', {}, [
      c(Modal, {
        props: {
          value: false,
          width: this.width,
          maskClosable: false,
          title: this.inTitle,
          styles: this.styles,
          className: this.className
        },
        attrs: {
          ...this.$attrs
        },
        ref: 'customModal',
        class: {
          'iv-custom-modal': true,
          'iv-middle': this.isMiddle,
          'iv-full': this.size == 'full'
        },
        scopedSlots: {
          default: props => {
            return c('div', this.$slots.default)
          },
          ...this.$slots.header ? {
            header: props => {
              return c('div', this.$slots.header)
            }
          } : {},
          ...this.$slots.footer ? {
            footer: props => {
              return c('div', this.$slots.footer)
            }
          } : {
            footer: props => {
              const vNode = this.readOnly ? c('div', {}, [
                c('Button', {
                  props: {
                    type: 'cancel',
                    noIcon: true
                  },
                  nativeOn: {
                    click: () => {
                      this.close()
                    }
                  }
                }, '取消')
              ]) : c('div', {}, [
                c('Button', {
                  props: {
                    type: 'sure',
                    noIcon: true
                  },
                  nativeOn: {
                    click: () => {
                      this.$emit('on-ok')
                    }
                  }
                }, this.buttonText),
                c('Button', {
                  props: {
                    type: 'cancel',
                    noIcon: true
                  },
                  nativeOn: {
                    click: () => {
                      this.close()
                    }
                  }
                }, '取消')
              ])
              return vNode
            }
          }
        },
        on: {
          'on-ok': () => {
            this.$emit('on-ok')
          },
          'on-cancel': () => {
            this.close()
            this.removeHidden()
          },
          'on-hidden': () => {
            this.showModal = false
            this.removeHidden()
            this.$emit('on-hidden')
          },
          'on-visible-change': (val) => {
            this.$emit('on-visible', val)
          }
        }
      }, [this.$slots.header ? c('div', {
        slot: 'header'
      }, this.$slots.header) : ''])
    ]) : c('')
  },
  methods: {
    close () {
      this.showModal = false
      this.$refs.customModal.visible = false
      this.removeHidden()
      this.$emit('input', false)
      this.$emit('on-cancel')
    },
    open () {
      this.showModal = true
      this.$nextTick(() => {
        this.$refs.customModal.visible = true
        this.removeHidden()
      })
    },
    setTitle (title) {
      this.inTitle = title
    },
    removeHidden () {
      let ishidden = document.body.style.overflow === 'hidden'
      ishidden && (document.body.style.overflow = 'initial')
    },
    addUitClass () {
      //无法装饰者模式修改，只能使用原生侵入式修改DOM
      let footerEl = document.querySelector('.iv-custom-modal .ivu-modal-footer')
      if (!footerEl) return
      footerEl.children[0] && footerEl.children[0].classList.add('iv-custom-modal-cancel')
      footerEl.children[1] && footerEl.children[1].classList.add('iv-custom-modal-save')
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/base/variable.scss';
.iv-custom-modal {
  .ivu-btn-loading {
    pointer-events: initial;
    &:before {
      display: none;
    }
    i {
      display: none;
    }
    span {
      margin-left: 0;
    }
  }
  .ivu-modal-footer {
    text-align: center;
    .ivu-btn-text {
      border-color: #dddee1;
    }
  }
  .ivu-modal-header {
    .ivu-modal-header-inner {
      font-size: 16px;
    }
  }
  .ivu-modal-body {
    padding: 0;
    max-height: 625px;
    min-width: 236px;
    overflow: auto;
  }
  &.iv-middle {
    .ivu-modal-body {
      padding: 0;
    }
  }
  &.iv-full {
    .ivu-modal-content{
      height: 100%;
    }
    .ivu-modal-body {
      position: relative;
      height: calc(100vh - 103px);
      max-height: calc(100vh - 103px);
    }
  }
}
</style>
